// import { useMediaQuery } from "@mui/material";
import { useRef, useCallback, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import styled from "styled-components";
import { useMediaQuery } from "react-responsive";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

const wvideo1 = require("assets/history/display/1.mp4");
const wvideo2 = require("assets/history/display/2.mp4");
const wvideo3 = require("assets/history/display/3.mp4");
const wvideo4 = require("assets/history/display/4.mp4");

const mvideo1 = require("assets/history/mobile/1.mp4");
const mvideo2 = require("assets/history/mobile/2.mp4");
const mvideo3 = require("assets/history/mobile/3.mp4");
const mvideo4 = require("assets/history/mobile/4.mp4");

const CarouselStyleWrapper = styled.section`
  .video-container {
    height: 100vh;
    display: block;
    position: relative;
  }

  .video-container > video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: 0;
  }

  .video-container .message {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 90%;
  }

  .video-container .message > p {
    -webkit-text-stroke: 1px black; /* width and color */
    max-width: 80%;
    font-size: 40px;
    font-weight: black;
  }

  .video-container .actions {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .play {
    background-image: url(/play.png);
    background-size: cover;
    cursor: pointer;
    opacity: 0.1;
    height: 250px;
    width: 250px;
  }
`;

interface VideoProps {
  src: string;
  message: string;
}

const Video = ({ src, message }: VideoProps) => {
  const videoRef = useRef<any>(null);
  const [playing, setPlaying] = useState(false);

  const handlePlayPause = useCallback(() => {
    videoRef.current.play();
    videoRef.current.onpause = () => {
      setPlaying(false);
    };
    setPlaying(true);
  }, [videoRef]);

  return (
    <div className="video-container">
      <video ref={videoRef}>
        <source src={src} type="video/mp4" />
      </video>
      <div className="message">
        <p>{message}</p>
      </div>
      <div className="actions">{!playing && <div onClick={handlePlayPause} className="play" />}</div>
    </div>
  );
};

export default function VideoCarousel() {
  const isPortrait = useMediaQuery({ query: "(orientation: portrait)" });

  const carouselRef = useRef<any>(null);

  const videos = [
    { landscape: wvideo1, portrait: mvideo1, message: "Lorem ipsum dolor sit amet consectetur adipisicing elit." },
    {
      landscape: wvideo2,
      portrait: mvideo2,
      message: "Earum unde voluptate at facilis aliquam nemo reiciendis aspernatur!",
    },
    { landscape: wvideo3, portrait: mvideo3, message: "Deleniti perspiciatis minus, excepturi," },
    {
      landscape: wvideo4,
      portrait: mvideo4,
      message: "fugit rerum explicabo consequatur voluptatem ipsam asperiores at molestiae.",
    },
  ];

  return (
    <CarouselStyleWrapper>
      <Carousel
        autoPlay={false}
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        useKeyboardArrows
        transitionTime={0}
        dynamicHeight
        ref={carouselRef}
      >
        {videos.map((v, i) => (
          <Video key={i} src={isPortrait ? v.portrait : v.landscape} message={v.message} />
        ))}
      </Carousel>
    </CarouselStyleWrapper>
  );
}
